<template>
    <div>
        <div>
            <div class="tit-wrap mb-3">
                <v-layout align-center>
                    <h3 class="tit tit--xs">최근 캐시 사용 내역</h3>
                    <v-btn dense small text color="grey" to="/mypage/cashes/inquiry" class="my-n2">더보기 <v-icon>mdi-chevron-right</v-icon> </v-btn>
                </v-layout>
            </div>

            <div>
                <v-data-table :items="cashes" :headers="cashesHeaders" hide-default-footer disable-pagination disable-sort no-data-text="구매 내역이 없습니다.">
                    <span slot="item.createdAt" slot-scope="{ item }">{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
                    <span slot="item.amount" slot-scope="{ item }">{{ parseInt(+item.amount || 0).format() }}원</span>
                    <span slot="item.result" slot-scope="{ item }">{{ parseInt(+item.result || 0).format() }}원</span>
                </v-data-table>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";

export default {
    data() {
        return {
            page: 1,
            pageCount: 0,
            limit: 10,

            cashes: [],
            cashesHeaders: [
                { text: "캐시일자", value: "createdAt", align: "center", width: 200 },
                { text: "비고", value: "remark", align: "center" },
                { text: "금액", value: "amount", align: "center", width: 150 },
                { text: "남은금액", value: "result", align: "center", width: 150 },
            ],
            me: null,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            let { me } = await api.v1.me.profile.get();
            this.me = me;

            this.search();
        },
        async search(routable = false) {
            let { summary, cashes } = await api.v1.me.cashes.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit,
                },
            });

            this.cashes = cashes;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
    },
};
</script>
